import { render, staticRenderFns } from "./PrivacyLog.vue?vue&type=template&id=3e43e7fb&scoped=true&"
import script from "./PrivacyLog.vue?vue&type=script&lang=js&"
export * from "./PrivacyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43e7fb",
  null
  
)

export default component.exports